import styled from 'styled-components'
import { Breakpoints, Colors } from '../../constants'

export const fontSizes = {
  xxs: 14,
  xs: 16,
  s: 18,
  m: 20,
  l: 24,
  xl: 28,
  xxl: 32,
  xxxl: 38,
  xxxxl: 42,
  xxxxxl: 48,
  xxxxxxl: 52,
}

export const TitleH1 = styled.h1`
  padding: 0;
  margin: 0;
  font-weight: 700;
  color: ${Colors.WHITE};

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    font-size: ${fontSizes.m + 2}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.l}px;
    line-height: ${fontSizes.xl}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.xl}px;
    line-height: ${fontSizes.xxxl}px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET}px) {
    font-size: ${fontSizes.xxl}px;
    line-height: ${fontSizes.xxxl}px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    font-size: ${fontSizes.xxxl}px;
    line-height: ${fontSizes.xxxxl}px;
  }

  @media only screen and (min-width: ${Breakpoints.DESKTOP}px) {
    font-size: ${fontSizes.xxxxl}px;
    line-height: ${fontSizes.xxxxxl}px;
  }
`

export const TitleH2 = styled.h2`
  margin: 0;
  padding: 0;
  color: ${Colors.WHITE};
  font-weight: 400;

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    font-size: ${fontSizes.s}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.m}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.m}px;
    line-height: ${fontSizes.xl}px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    font-size: ${fontSizes.l}px;
    line-height: ${fontSizes.xl}px;
  }

  @media only screen and (min-width: ${Breakpoints.DESKTOP}px) {
    font-size: ${fontSizes.xl}px;
    line-height: ${fontSizes.xxl}px;
  }
`

export const TitleH3 = styled.h3`
  margin: 0;
  padding: 0;
  color: ${Colors.WHITE};
  font-weight: 400;

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    font-size: ${fontSizes.xs}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.s}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.m}px;
    line-height: ${fontSizes.xl}px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    font-size: ${fontSizes.l}px;
    line-height: ${fontSizes.xxl}px;
  }
`

export const TitleH4 = styled.h4<{ color?: string }>`
  margin: 0;
  padding: 0;
  color: ${(p) => (p.color ? p.color : Colors.WHITE)};
  font-weight: 400;

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    font-size: ${fontSizes.xs}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.s}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.m}px;
    line-height: ${fontSizes.xl}px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    font-size: ${fontSizes.l}px;
    line-height: ${fontSizes.xxl}px;
  }
`

export const TitleH5 = styled.h5<{ color?: string }>`
  margin: 0;
  padding: 0;
  color: ${(p) => (p.color ? p.color : Colors.WHITE)};
  font-weight: 400;

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    font-size: ${fontSizes.xs}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.s}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.m}px;
    line-height: ${fontSizes.xl}px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    font-size: ${fontSizes.l}px;
    line-height: ${fontSizes.xxl}px;
  }
`

export const BodyText = styled.p<{ size?: 's' | 'm' | 'l' }>`
  margin: 0;
  padding: 0;
  color: ${Colors.WHITE};

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    font-size: ${fontSizes.xs}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.xs}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.xs}px;
    line-height: ${fontSizes.l}px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET}px) {
    font-size: ${fontSizes.s}px;
    line-height: ${fontSizes.xl}px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET_LANDSCAPE}px) {
    font-size: ${fontSizes.s}px;
    line-height: ${fontSizes.xl}px;
  }

  @media only screen and (min-width: ${Breakpoints.DESKTOP}px) {
    font-size: ${fontSizes.s}px;
    line-height: ${fontSizes.xl}px;
  }
`

export const FinePrint = styled.p`
  margin: 0;
  padding: 0;
  font-size: ${fontSizes.xxs}px;
  font-weight: 400;
  line-height: ${fontSizes.l}px;
  color: ${Colors.WATERLOO};

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    font-size: ${fontSizes.xs}px;
  }
`
